import { jsonataWithCallback } from '../expressions/expressions';

type JsonataParams = {
  expression: string;
  state: unknown;
};

type JsonataResponse = {
  data: unknown;
};

export const jsonata = async ({ expression, state }: JsonataParams): Promise<JsonataResponse> => {
  const resp = await jsonataWithCallback(expression, state);
  return { data: resp === undefined ? '' : resp };
};
